@if (products$ | async; as products) {
  <div class="mt-28">
    <div
      class="mb-5 text-4xl font-bold"
      [style.color]="textColor() | contentBuilderColor"
    >
      {{ heading() | translate }}
    </div>
    <div
      class="grid grid-cols-3 gap-3 overflow-x-auto scroll-smooth scrollbar-hide"
      #carousel
    >
      @for (product of products; track product) {
        <div class="h-full">
          @if (product) {
            <app-kiosk-product-card-atom
              class="flex h-full min-h-[250px] flex-col justify-between"
              [class]="optionCardType()"
              [product]="product"
              [quantity]="product.quantity"
              [isProductAvailable]="!!product.available"
              [selectionnable]="product.available"
              (addProduct)="navigateToProduct(product)"
              [textColor]="textColor()"
              [buttonBackgroundColor]="primaryButtonBackgroundColor()"
              [buttonTextColor]="primaryButtonTextColor()"
            ></app-kiosk-product-card-atom>
          }
        </div>
      }
    </div>
  </div>
}
